import { Sidenav } from '@app/components/layout/sidenav/Sidenav';
import { useAuth } from '@app/core/auth/authentication/hooks';
import { useStations } from '@app/core/stations/hooks/useStations';
import { ModulesNavLinks } from '@app/modules/ModulesNavLinks';
import { parseAsBoolean, useQueryState } from 'nuqs';

/**
 * App-wired sidenav: hidden in fullscreen query mode; module links omitted for
 * superadmin or when the user has no stations (avoids station-dependent crashes).
 */
export function AppSidenav() {
  const [isFullscreen] = useQueryState('fullscreen', parseAsBoolean);
  const { isSuperadmin } = useAuth();
  const stations = useStations();
  const showModuleLinks = !isSuperadmin && stations.length > 0;

  if (isFullscreen) {
    return null;
  }

  return <Sidenav>{showModuleLinks ? <ModulesNavLinks /> : null}</Sidenav>;
}
